module.exports = __webpack_public_path__ + "static/wb_logo_v2_v-31d9b4556234e8d3a4c50850f008db79.svg";